import * as Immutable from 'immutable';
import PriceStore from '../../UIData/_stores/PriceStore';

export type ViewProductGpsrManufacturingMethod = 'made_in_house' | 'premade'

export interface ViewProductGpsrInfo {
    material: string | null
    id_manufacturer: number | null
    id_gpsr_contact: number | null
    hs_code: string | null
    id_country_of_manufacture: number | null
    manufacturing_method: ViewProductGpsrManufacturingMethod | null
    manufacturing_value_added: string | null
    usmca_compliant: boolean
    raw_material_source: string | null
    raw_material_address: string | null
    material_certification: string | null
    flammability_test_year: string | null
    risks: string | null
    risk_management: string | null
    warranty: string | null
    care_instructions: string | null
}

export type ViewProductGpsrInfoStore = Immutable.Map<keyof ViewProductGpsrInfo, string | number | boolean | null>

export interface IViewProductStore {
	id: number
    id_product: number | null
    id_reward: number | null
    description: string
    categories: Immutable.OrderedSet<number>
    listAttributes: Immutable.OrderedMap<string, number>
    pricingOptions: Immutable.OrderedSet<number>
    name: string
    price: PriceStore
    starting_wholesale_price: PriceStore | null
    starting_set_price: PriceStore | null
    starting_set_quantity: number | null
    slug: string
    url_slug: string
    url_slugs: Immutable.Map<string, string>
    is_new: boolean
    featured_order: number | null
    bestseller_order: number | null
    is_react_page: boolean
    gpsrInfo: ViewProductGpsrInfoStore | null
}

const defaultViewProductStore = Immutable.Record<IViewProductStore>({
	id: 0,
    id_product: null,
    id_reward: null,
    description: '',
    categories: Immutable.OrderedSet<number>(),
    listAttributes: Immutable.OrderedMap<string, number>(),
    pricingOptions: Immutable.OrderedSet<number>(),
	name: '',
	price: new PriceStore(),
    starting_wholesale_price: null,
    starting_set_price: null,
    starting_set_quantity: null,
	slug: '',
    url_slug: '',
    url_slugs: Immutable.Map<string, string>(),
    is_new: false,
    featured_order: null,
    bestseller_order: null,
    is_react_page: false,
    gpsrInfo: null,
});

export default class ViewProductStore extends defaultViewProductStore implements IViewProductStore {}
